// extracted by mini-css-extract-plugin
export default {"container":"ChartVariation_container__h4coR","chart":"ChartVariation_chart__Zjyms","empty":"ChartVariation_empty__71qqN"};